import { tableStyles } from "./styles";

export default {
  styleOverrides: {
    root: {
      ...tableStyles.tableList,
      padding: "10px 6px"
    },
  },
  variants: [
    {
      props: { variant: "select" },
      style: {
        ...tableStyles.tableHeader
      },
    },
  ],
};
